import { Injectable } from '@angular/core';
import { Membership, UserInfo } from './user-info';
import { UserRole } from './user-enums';

@Injectable({
  providedIn: 'root',
})
export class UserUIService {
  isUserGestor(user: UserInfo | undefined, tenantId: string | null) {
    if (!user || !tenantId) return false;
    let membership: Membership | undefined = user.memberships.find(
      (membership) => membership.schema_id == tenantId
    );
    return membership?.role == UserRole.GESTOR;
  }

  isAdmin(user: UserInfo | undefined, tenantId: string | null) {
    if (!user || !tenantId) return false;
    let membership: Membership | undefined = user.memberships.find(
      (membership) => membership.schema_id == tenantId
    );
    return membership?.role == UserRole.ADMIN;
  }

  isGestorOrAdmin(user: UserInfo | undefined, tenantId: string | null) {
    return this.isUserGestor(user, tenantId) || this.isAdmin(user, tenantId);
  }
}
